module.exports = __webpack_public_path__ + "img/kids-6.ff12e37b.jpg";